import { render, staticRenderFns } from "./programme.vue?vue&type=template&id=141c76ec&scoped=true"
var script = {}
import style0 from "./programme.vue?vue&type=style&index=0&id=141c76ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141c76ec",
  null
  
)

export default component.exports